import {
    globalURL,
    fetchApiHeaders
} from "../../helpers/constants";


export const addToShoppingCart = (token, product, color, size, quantity, addToast, strings, hideAlert, history) => dispatch => {
    dispatch({
        type: "GET_ADD_TO_CART"
    });

    fetch(globalURL + "/cart/addToCart", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        },
        body: JSON.stringify({
            quantity: quantity,
            product: product,
            color: color,
            size: size
        })
    })
        .then((result) => result.json())
        .then(async (addCart) => {
            if (addCart.success) {
                if (hideAlert === undefined) {
                    addToast(strings['alerts']['addedToCart'], {
                        appearance: "success",
                        autoDismiss: true
                    });
                }

                dispatch({
                    type: "FETCH_ADD_TO_CART"
                });

                dispatch({
                    type: "FETCH_USER_CART_DETAIL",
                    payload: addCart.data
                });

                if (history) {
                    history.push("/checkout");
                }

            } else {
                if (addCart.type) {
                    switch (addCart.type) {
                        case "soldOut":
                            addToast(strings["alerts"]["soldOut"], { appearance: "error", autoDismiss: true });
                            break;
                        case "insufficientStock":
                            addToast(strings["alerts"]["insufficientStock"], { appearance: "error", autoDismiss: true });
                            break;
                    }
                } else {
                    addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
                }
            }
        })
        .catch((error) => {
            console.log(error)
            dispatch({
                type: "ERROR_ADD_TO_CART"
            });
            addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
        })
}

export const removeFromShoppingCart = (token, stockCard, addToast, strings) => dispatch => {
    fetch(globalURL + "/cart/removeFromCart", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        },
        body: JSON.stringify({
            stockCard: stockCard
        })
    })
        .then((result) => result.json())
        .then(async (remove) => {
            if (remove.success) {
                dispatch({
                    type: "FETCH_USER_CART_DETAIL",
                    payload: remove.data
                });

            } else {
                addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
            }
        })
        .catch((error) => {
            console.log(error)
            addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
        })
}

export const decreaseCartQuantity = (token, stockCard, addToast, strings) => dispatch => {
    fetch(globalURL + "/cart/decreaseCartQuantity", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        },
        body: JSON.stringify({
            stockCard: stockCard
        })
    })
        .then((result) => result.json())
        .then(async (decreaseCart) => {
            if (decreaseCart.success) {
                dispatch({
                    type: "FETCH_USER_CART_DETAIL",
                    payload: decreaseCart.data
                });

            } else {
                addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
            }
        })
        .catch((error) => {
            console.log(error)
            addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
        })
}

export const increaseCartQuantity = (token, stockCard, addToast, strings) => dispatch => {
    fetch(globalURL + "/cart/increaseCartQuantity", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        },
        body: JSON.stringify({
            stockCard: stockCard
        })
    })
        .then((result) => result.json())
        .then(async (increaseCart) => {
            if (increaseCart.success) {
                dispatch({
                    type: "FETCH_USER_CART_DETAIL",
                    payload: increaseCart.data
                });

            } else {
                if (increaseCart.type) {
                    switch (increaseCart.type) {
                        case "soldOut":
                            addToast(strings["alerts"]["soldOut"], { appearance: "error", autoDismiss: true });
                            break;
                        case "insufficientStock":
                            addToast(strings["alerts"]["insufficientStock"], { appearance: "error", autoDismiss: true });
                            break;
                    }
                } else {
                    addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
                }
            }
        })
        .catch((error) => {
            console.log(error)
            addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
        })
}

export const clearShoppingCart = (token, addToast, strings) => dispatch => {
    fetch(globalURL + "/cart/clearAll", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        }
    })
        .then((result) => result.json())
        .then(async (clear) => {
            if (clear.success) {
                dispatch({
                    type: "FETCH_USER_CART_DETAIL",
                    payload: clear.data
                });

            } else {
                addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
            }
        })
        .catch((error) => {
            console.log(error)
            addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
        })
}

export const getUserCartDetail = (token, addToast, strings) => dispatch => {
    dispatch({
        type: "GET_USER_CART_DETAIL"
    });
    fetch(globalURL + "/cart/getUserCartDetail", {
        method: 'POST',
        headers: {
            ...fetchApiHeaders.POST,
            token: token
        }
    })
        .then((result) => result.json())
        .then(async (cartList) => {
            if (cartList.success) {
                dispatch({
                    type: "FETCH_USER_CART_DETAIL",
                    payload: cartList.data
                });

                dispatch({
                    type: "STOP_LOADING_PAYMENT"
                })

            } else {
                addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
                dispatch({
                    type: "ERROR_USER_CART_DETAIL"
                });
            }
        })
        .catch((error) => {
            console.log(error)
            addToast(strings["alerts"]["error"], { appearance: "error", autoDismiss: true });
        })
}